module.exports = __webpack_public_path__ + "static/media/agente_outbound_icon.a19ca630.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/agente_outbound_icon.svg
// module id = 1779
// module chunks = 0